import { graphql } from "react-relay";

export const change_password = graphql`
  mutation ChangePasswordMutation($input: ChangePasswordInput!) {
    changePassword(input: $input) {
      success
      errors
    }
  }
`;
